import { css } from '@emotion/react'
import { t } from '@lingui/core/macro'
import { Alert, Button } from '@mui/material'
import { Loader } from '@components'
import { IDatasetIntegrationExecution } from '../../../datasetHistoryV2/types'

const noWrapButton = css`
  white-space: nowrap;
`

const flex = css`
  display: flex;
`

interface Props {
  loading: boolean
  execution: IDatasetIntegrationExecution
  refreshGAIntegrationStatus: (execution: IDatasetIntegrationExecution) => void
}

export const GoogleAnalyticsExecution = ({
  loading,
  execution,
  refreshGAIntegrationStatus,
}: Props) => (
  <div>
    {loading ? (
      <Loader />
    ) : (
      <Alert
        severity="info"
        action={
          <Button
            onClick={() => {
              refreshGAIntegrationStatus(execution)
            }}
            css={noWrapButton}
          >
            {t`Update status`}
          </Button>
        }
      >
        <div css={flex}>
          <div>
            <div>
              {t`Remote job ID:`}
              {execution?.remote_job_id}
            </div>
            <div>{execution?.api_response}</div>
          </div>
        </div>
      </Alert>
    )}
  </div>
)
